export default "__VITE_ASSET__Co_pyhmr__"